import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import { Link, useHistory } from 'react-router-dom';
import Spinner from 'react-spinkit';
import UsersDataTable from '../../components/UsersDataTable/index';
import { fetchUsersRequested } from '../../store/users/actions';

function UsersPage () {
  const history = useHistory();
  const dispatch = useDispatch();
  const { query } = queryString.parseUrl(history.location.search);
  const { isUsersLoading, users } = useSelector(state => state.users);
  const [namePrefix, setNamePrefix] = useState(decodeURI(query.searsch || ''));
  const columns = useMemo(() => ([
    {
      field: 'id',
      title: 'id',
      render: rowData => (<Link
        className="nav-link"
        to={{
          pathname: '/dashboard/users/' + rowData.id + '/detail',
        }}
      >
        {rowData.id}
      </Link>)
    },
    {
      field: 'display_name',
      title: 'Имя'
    },
    {
      field: 'phone_number',
      title: 'Телефон'
    },
    {
      field: 'instagram_account',
      title: 'Instagram'
    },
    {
      field: 'vk_account',
      title: 'Vk'
    },
    {
      field: 'facebook_account',
      title: 'Facebook'
    },
    {
      field: 'skills',
      title: 'Рекоммендации',
      render: rowData => (<p
        style={{
          width: '200',
          // minWidth: '270px'
        }}
      >
        <span>Открытые категории:</span>
        {skillsRow(rowData)}
        <br/>
        <span>Не открытые категории:</span>
        {recommendationsRow(rowData)}
      </p>)
    },
    {
      field: 'description',
      title: 'Описание',
      render: rowData => <p
        style={{
          width: '150',
        }}
      >{rowData.description}</p>
    },
    {
      field: 'internal_description',
      title: 'Внутренний комментарий',
      render: rowData => <p style={{
        width:'150',
      }}>{rowData.internal_description}</p>
    },
  ]), []);


  useEffect(() => {
    if (namePrefix) {
      dispatch(fetchUsersRequested({ namePrefix }));
    }
  }, []);

  const handleSearch = (event) => {
    event.preventDefault();
    dispatch(fetchUsersRequested({ namePrefix }));
    history.push({
      pathname: '/dashboard/users',
      search: `?searsch=${encodeURIComponent(namePrefix)}`,
    });
  };

  const skillsRow = (rowData) => (
    rowData.skills.map((skill) =>
      <Link
        className="nav-link"
        to="/dashboard/users"
        key={rowData.id + '_' + skill.id}
      >
        {skill.name} ({countBySkillFromRecommendations(skill, rowData.recommendations)})
      </Link>
    )
  );

  const recommendationsRow = (rowData) => (rowData.recommendations
      .filter((recommendation) =>
        rowData.skills.find((eachSkill) => eachSkill.id === recommendation.skill.id) === undefined
      )
      .map((recommendation) =>
        <Link
          className="nav-link"
          to={`/dashboard/users/${rowData.id}/edit`}
          key={'recommendation_' + rowData.id + '_' + recommendation.skill.id}
        >
          {recommendation.skill.name} ({recommendation.count})
        </Link>
      )
  );

  const countBySkillFromRecommendations = (skill, recommendations) => {
    const foundRecommendation = recommendations.find((eachRecommendation) => eachRecommendation.skill.id === skill.id);
    if (foundRecommendation !== undefined) {
      return foundRecommendation.count;
    } else {
      return 0;
    }
  };

  const onDetail = (rowData) => {
    history.push(`/dashboard/users/${rowData.id}/detail`);
  };

  const onEdit = (rowData) => {
    history.push(`/dashboard/users/${rowData.id}/edit`);
  };
  return (
    <div
      style={{ width: '100%' }}
    >
      {
        isUsersLoading &&
        <div>
          <Spinner name="circle" className="spinner" fadeIn="quarter" color="#3897dc"/>
          <div className="overlay">
          </div>
        </div>
      }
      <div>
        <h3>Пользователи</h3>
        <form
          className="form-inline"
          onSubmit={handleSearch}
        >
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Поиск..."
              aria-label="Search"
              aria-describedby="basic-addon2"
              value={namePrefix}
              onChange={(event) => {
                setNamePrefix(event.target.value);
              }}
            />
            <div className="input-group-append">
              <button className="btn btn-primary" type="submit">
                <i className="fas fa-search"/>
              </button>
            </div>
          </div>
        </form>
      </div>
      <br/>
      <UsersDataTable
        data={users.map(o => ({ ...o }))}
        columns={columns}
        onEdit={onEdit}
        onDetail={onDetail}
      />
    </div>
  );
}
export default UsersPage;



// WEBPACK FOOTER //
// ./src/pages/UsersPage/index.jsx